import { config } from "../config.js";

// 面(1〜6)ごとの試合の作り(2026-10-31 オーナー決定。値は config.missions)。
// 今の構成(config.stages・enemies.roster・holds・bossAt・spawnCurve)を土台に、面ごとの長さ・出る敵・停止戦・強さを重ねる。
// sim の中の「今の面」は step の最初に world.params.mission から決める(useMission)。描画・画面もこれを読む。
// 試合の前に決まる値だけで作るので、リプレイ・R.W.N.D.も同じになる。

const cache = new Map();
let active = null;

export const MISSION_COUNT = config.missions.length;

// n: 1〜MISSION_COUNT
export function useMission(n) {
  if (!cache.has(n)) cache.set(n, compile(n));
  active = cache.get(n);
  return active;
}

export function mission() {
  return active || useMission(3);
}

export function missionInfo(n) {
  if (!cache.has(n)) cache.set(n, compile(n));
  return cache.get(n);
}

function compile(n) {
  const m = config.missions[n - 1] || config.missions[2];
  const ec = config.enemies;
  const roster = m.roster ? ec.roster.filter((it) => it.type in m.roster).map((it) => ({ ...it, from: m.roster[it.type] })) : ec.roster;
  const baseHolds = config.holds.list;
  const holds = m.holds
    ? m.holds.map(({ base, ...over }) => ({ ...baseHolds[base], ...over }))
    : baseHolds.map((h, i) => (i === baseHolds.length - 1 ? { ...h, final: true } : h));
  const stages = m.areas ? config.stages.filter((s) => s.id in m.areas).map((s) => ({ ...s, from: m.areas[s.id] })) : config.stages;
  const finale = m.holds ? holds[holds.length - 1].leader : m.boss != null ? "boss" : holds[holds.length - 1].leader || "boss";
  return {
    n,
    name: m.name,
    runSeconds: m.length || config.sim.runSeconds,
    minutes: m.minutes || 4, // カードに出す目安の長さ(停止戦の分を含む。2026-11-01 の圧縮後、3面〜は自動操作で約4分)
    roster,
    holds,
    bossAt: m.boss === undefined ? ec.bossAt : m.boss,
    bossFinal: !!m.bossFinal,
    stages,
    spawnCurve: m.spawnCurve || ec.spawnCurve,
    enemy: { hp: 1, damage: 1, spawn: 1, growth: 1, ...m.enemy },
    dopa: m.dopa || 1,
    clear: m.clear || {},
    finale: m.boss != null && m.bossFinal ? "boss" : finale,
  };
}
